<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/DHT3L/DHT3L.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">3DHT215</div>
                <div class="detail-banner-desc transmission">Single-motor, longitudinally mounted power-split 3-speed DHT
                    <div class="detail-desc">
                        <div>
                            Equipped with multiple modes including power-split, direct drive, range extension, hybrid,
                            and EV, the highly efficient power-split module ensures that the engine always operates
                            within its optimal efficiency range;<br />
                        </div>
                        <div>
                            With an ultra-high gear ratio of 20, under 4L mode, it can deliver a wheel-end torque
                            exceeding 8000N·m;<br />
                        </div>
                        <div>
                            Even under regenerative charging conditions, it can maintain continuous power output;<br />
                        </div>
                        <div>
                            The motor adopts a composite structure featuring water-cooling and oil-cooling, as well as a
                            hairpin winding design, enhancing the proportion of operation in the high-efficiency
                            range;<br />
                        </div>
                        <div>
                            An integrated electronic control shift system delivers rapid response and smooth gear
                            shifts;<br />
                        </div>
                        <div>
                            Equipped with an intelligent lubrication system that precisely allocates flow rates on
                            demand, thereby reducing oil-churning losses.<br />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="one-titile">
                    Core Configuration
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">215kW</div>
                                    <div class="k">Peak Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">400N·m</div>
                                    <div class="k">Peak Torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">7000rpm</div>
                                    <div class="k">Maximum Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3+R</div>
                                    <div class="k">Gear</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Water & oil cooling</div>
                                    <div class="k">Motor Cooling Type</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/DHT3L/DHT3L-2.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '3DHT215 - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/transmission/DHT3L.html'
};

import { createApp } from 'vue';
import App from './DHT3L.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./DHT3L.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
